import { PureComponent } from "react";
import NoTicketSvg from "../../../svgs/noticket";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaCreateHero from "../../ui-kit/kuika-create-hero/kuika-create-hero";

interface Props {
  onClickCreate: (value: boolean) => void;
}

interface State {}

class NoTicket extends PureComponent<Props, State> {
  render() {
    return (
      <KuikaCreateHero
        illustration={<NoTicketSvg />}
        title="You don't have any tickets"
        description={
          <>
            Need help? Create a ticket. We will get back to you <br /> as soon as possible.
          </>
        }
      >
        <KuikaButton onClick={() => this.props.onClickCreate(true)}>Create</KuikaButton>
      </KuikaCreateHero>
    );
  }
}

export default NoTicket;
